import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as notificationTypeState from '../static-data.reducer';
import * as notificationTypeReducer from '../reducers/notification-types.reducer';

export const selectNotificationTypes = createSelector(
  notificationTypeState.selectNotificationTypeState,
  notificationTypeReducer.getNotificationTypes
);
